import { del, get, post, put } from './request'


interface  GuestRooms {
    supplier: any;
    propertyId: any;
    property: {
        guestrooms: {
            guestroom: any[];
        };
    };
}

//  type 
export const getGuestroomsTable = (supplier: string, propertyid: string) => get(`/property/guestrooms?supplier=${supplier}&propertyid=${propertyid}`)

//Guestroom room
export const addGuestRoom = (guestrooms: GuestRooms) => post('/property/guestroom/room', guestrooms)
export const updateGuestRoom = (guestrooms: GuestRooms) => put('/property/guestroom/room', guestrooms)
export const deleteGuestRoom = (guestrooms: GuestRooms) => del('/property/guestroom/room', guestrooms)

// //Guestroom images
// export const addImage = (guestrooms: GuestRooms) => post('/property/guestroom/images', guestrooms)
// export const updateImage = (guestrooms: GuestRooms) => put('/property/', guestrooms)
// export const deleteImage = (guestrooms: GuestRooms) => del('/property/', guestrooms)

// //Guestroom amenities
export const addGuestRoomAmenities = (guestrooms: GuestRooms) => post('/property/guestroom/amenities', guestrooms)
export const updateGuestRoomAmenities = (guestrooms: GuestRooms) => put('/property/guestroom/amenities', guestrooms)



// // Guestroom feature
export const addGuestRoomFeature = (guestrooms: GuestRooms) => post('/property/guestroom/features', guestrooms)
export const updateGuestRoomFeature = (guestrooms: GuestRooms) => put('/property/guestroom/features', guestrooms)


// // Guestroom details
export const addGuestRoomDetails = (guestrooms: GuestRooms) => post('/property/guestroom/details', guestrooms)
export const updateGuestRoomDetails = (guestrooms: GuestRooms) => put('/property/guestroom/details', guestrooms)
